import React from 'react';
import { ApolloProvider } from '@apollo/client';
import client from '../lib/apolloClient';
import PartnerSignupWizard from '../components/Succeedo/PartnerSignup/PartnerSignupWizard';

// Public partner signup page. No auth required, no GraphQL queries upfront.
// Wrapped in ApolloProvider for consistency with the rest of the app even
// though the wizard itself uses fetch() against the controller.
const SucceedoPartnerSignupContainer = (_props, _railsContext) => (
  <ApolloProvider client={client}>
    <PartnerSignupWizard />
  </ApolloProvider>
);

export default SucceedoPartnerSignupContainer;
